import { externalNetworkClient } from '@terra/shared-rest-clients-external-network';
import type { ExternalNetworkContract } from '@terra/shared-contracts-external-network';
import type {
  ExternalNetworkScanListQueryDto,
  TriggerScanType,
} from '@terra/shared-contracts-external-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const surfaceScansApi = {
  listExternalNetworkScans: ({
    surfaceId,
    query = {},
  }: {
    surfaceId: string;
    query?: ExternalNetworkScanListQueryDto;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.listScans>({
      endpointFn: (headers) =>
        externalNetworkClient.listScans({
          params: { surfaceId },
          query,
          ...withOrchestratorClient(headers),
        }),
    }),

  triggerExternalNetworkScan: ({
    surfaceId,
    scanType,
  }: {
    surfaceId: string;
    scanType: TriggerScanType;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.triggerScan>({
      endpointFn: (headers) =>
        externalNetworkClient.triggerScan({
          params: { surfaceId },
          body: { scanType },
          ...withOrchestratorClient(headers),
        }),
    }),

  stopExternalNetworkScan: ({
    surfaceId,
    scanId,
  }: {
    surfaceId: string;
    scanId: string;
  }) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.stopScan>({
      endpointFn: (headers) =>
        externalNetworkClient.stopScan({
          params: { surfaceId, scanId },
          ...withOrchestratorClient(headers),
        }),
    }),
};
